import { useCallback, useEffect } from 'react';

export const useKeyboardShortcuts = (handlers = {}) => {
  const handleKeyDown = useCallback((e) => {
    const mod = e.metaKey || e.ctrlKey;
    const key = e.key.toLowerCase();

    if (mod && key === 'k') {
      e.preventDefault();
      handlers.onSearch?.();
      return;
    }
    if (mod && key === 'z' && !e.shiftKey) {
      e.preventDefault();
      handlers.onUndo?.();
      return;
    }
    if ((mod && key === 'y') || (mod && e.shiftKey && key === 'z')) {
      e.preventDefault();
      handlers.onRedo?.();
      return;
    }
    if (mod && key === 's') {
      e.preventDefault();
      handlers.onSave?.();
      return;
    }
    if (mod && key === 'd') {
      e.preventDefault();
      handlers.onDuplicate?.();
      return;
    }
    if (key === 'escape') {
      handlers.onEscape?.();
      return;
    }
    if ((key === 'delete' || key === 'backspace') && handlers.onDelete) {
      const tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || e.target.isContentEditable) return;
      e.preventDefault();
      handlers.onDelete?.();
    }
  }, [handlers]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
};

export default useKeyboardShortcuts;
